<template>
    <v-card :loading="loading">
        <v-card-title>
            <v-btn small icon @click="close" color="primary" class="ml-n3 mr-2">
                <v-icon>mdi-close</v-icon>
            </v-btn>
            <h2 class="font-weight-regular">
                EDIT OC & POSITION
            </h2>
        </v-card-title>
        <v-divider class="ml-4 mr-5" />
        <v-card-text>
            <v-form v-model="valid" class="mt-2 mb-0">
                <v-row no-gutters>
                    <v-col cols="12" xl="6" lg="6" md="6">
                        <v-combobox
                            v-model="item.oc"
                            :items="OCs"
                            item-text="name"
                            prepend-icon="mdi-cart-arrow-up"
                            label="OC: "
                        >
                        </v-combobox>
                    </v-col>
                    <v-col cols="12" xl="6" lg="6" md="6">
                        <v-combobox
                            :disabled="!item.oc"
                            v-model="item.costPosition"
                            :items="availablePositions"
                            item-text="name"
                            prepend-icon=" mdi-numeric"
                            label="Position: "
                        >
                        </v-combobox>
                    </v-col>
                </v-row>
            </v-form>
        </v-card-text>
        <v-card-actions>
            <v-spacer />
            <v-btn
                rounded
                color="primary"
                class="mb-5 mt-n4"
                @click="saveItem"
                :disabled="!canSave"
                :loading="loading"
            >
                SAVE
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import API from '@/services/api'
import { mapMutations } from 'vuex'

export default {
    name: 'OcAndPositionForm',
    props: {
        workOrder: {
            type: Object,
            default: () => ({}),
        },
        item: {
            type: Object,
            default: () => ({}),
        },
        originalItem: {
            type: Object,
            default: () => ({}),
        },
        OCs: {
            type: Array,
            default: () => [],
        },
        positions: {
            type: Object,
            default: () => ({}),
        },
    },
    data: () => ({
        valid: true,
        loading: false,
    }),
    computed: {
        availablePositions() {
            if (!this.item.oc) return []
            let ocId = null
            if (!this.item.oc || !this.positions) return []
            ocId =
                typeof this.item.oc === 'object' && this.item.oc !== null
                    ? this.item.oc.id || this.item.oc.name.trim()
                    : this.item.oc
            return this.positions[ocId] || []
        },
        canSave() {
            // Can save if: both are empty OR both are filled
            const hasOc =
                this.item.oc &&
                (typeof this.item.oc === 'string'
                    ? this.item.oc.trim() !== ''
                    : true)
            const hasPosition =
                this.item.costPosition &&
                (typeof this.item.costPosition === 'string'
                    ? this.item.costPosition.trim() !== ''
                    : true)
            return (!hasOc && !hasPosition) || (hasOc && hasPosition)
        },
    },
    watch: {
        'item.oc'(newValue, oldValue) {
            // Reset position when OC changes or is removed
            if (newValue !== oldValue) {
                this.$nextTick(() => {
                    if (!newValue || newValue === '') {
                        this.item.costPosition = null
                    } else if (oldValue !== undefined) {
                        this.item.costPosition = null
                    }
                })
            }
        },
    },
    methods: {
        ...mapMutations(['setErrorItems']),
        normalizeOcOrPosition(value) {
            if (value && typeof value === 'object' && value !== null) {
                return value.name || ''
            }
            return value || ''
        },
        async saveItem() {
            try {
                this.loading = true
                if (!this.item.oc) {
                    this.item.costPosition = ''
                }
                const updateItem = await API.updateWorkOrderItem({
                    workOrderId: this.workOrder.id,
                    partNumberId: this.item.partNumberId,
                    oc: this.normalizeOcOrPosition(this.item.oc),
                    costPosition: this.normalizeOcOrPosition(
                        this.item.costPosition
                    ),
                })
                this.$emit('replaceItem', updateItem)
                this.close()
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        close() {
            this.$emit('close')
        },
    },
}
</script>

<style></style>
